export default __webpack_public_path__ + "static/media/thirties-scene.b7b219a2.jpg";